export default __webpack_public_path__ + "assets/fonts/Avenir-Medium.woff2";